import { CONST } from "../CONST";
import { MinigameScene } from "../scenes/generic/MinigameScene";

export default class TryAgainButton extends Phaser.GameObjects.Image {
    constructor(x: number, y: number, scene: MinigameScene, texture: string){
        super(scene, x, y, texture);

        this.setInteractive({useHandCursor: true});
        this.on("pointerup", ()=> {
            scene.restartGame();

        });
        scene.add.existing(this);
    }
}